<template>
  <div class="SPASearch-container">
    <MDBInput
      inputGroup
      :formOutline="false"
      class="rounded"
      aria-describedby="search-addon"
      placeholder="Search..."
      v-bind="$attrs"
    >
      <template #prepend v-if="props.leftIcon">
        <span
          :class="[
            {
              'default-cursor': props.defaultCursor,
              'left-icon': props.leftIcon,
            },
            'input-group-text',
          ]"
          id="search-addon"
        >
          <IconSearch class="ph-icon" v-if="props.phIcon"
        /></span>
      </template>
      <span
        :class="[
          { 'default-cursor': props.defaultCursor },
          'input-group-text border-0',
        ]"
        id="search-addon"
        @click.prevent="handleClick"
        v-if="!props.leftIcon"
      >
        <em class="fas fa-search" v-if="!props.phIcon" />
        <IconSearch class="ph-icon" v-if="props.phIcon" />
      </span>
    </MDBInput>
  </div>
</template>

<script setup>
import { MDBInput } from 'mdb-vue-ui-kit';

import IconSearch from '~icons/ph/magnifying-glass';

const props = defineProps({
  phIcon: {
    type: Boolean,
    default: false,
  },
  leftIcon: {
    type: Boolean,
    default: false,
  },
  defaultCursor: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['clickSearch']);

const handleClick = () => {
  emit('clickSearch');
};
</script>

<style lang="scss" scoped>
.SPASearch-container {
  height: min-content;
  cursor: pointer;

  :deep(.input-group) {
    .form-control {
      padding-right: 40px;
      color: $neutral-500;
      border-color: $neutral-50;

      &::placeholder {
        color: $neutral-60;
      }

      ~ .input-group-text .fa-search,
      .ph-icon {
        color: $neutral-80;
      }

      &:focus {
        border-color: $green-300;
        box-shadow: none;
      }
    }

    .input-group-text {
      border: none;
      position: absolute;
      z-index: 999;
      left: calc(100% - 40px);

      &.left-icon {
        position: absolute;
        z-index: 999;
        left: 0;
        height: 100%;

        ~ .form-control {
          padding-right: 0;
          padding-left: 40px;
        }
      }
    }

    .input-group-text.default-cursor {
      cursor: default;
    }
  }

  &:focus-within {
    .ph-icon {
      color: $green-300;
    }
  }
}
</style>
